import React from 'react';
import { styled } from 'baseui';

const DefaultHighlighted = styled('span', {
	fontSize: 'var(--epods--font-size-p)',
	lineHeight: 'var(--epods--line-height-p)',
	fontFamily: 'var(--epods--font-secondary)',
	// Note: this is var(--epods--color-deeppurple-a-100) with 0.2 opacity
	backgroundColor: 'var(--epods--color-yellow-200)',
});

// @ts-ignore
export const StringWithMatches: React.FC<{
	text: string;
	matches: Array<[number, number]>;
	Highlighted?: React.ElementType<any>;
}> = ({ text, matches, Highlighted = DefaultHighlighted }) => {
	if (matches.length === 0) {
		return text;
	}

	return matches.reduce<React.ReactElement[]>((acc, [start, end], index) => {
		const Current: React.ReactElement = <Highlighted>{text.slice(start, end + 1)}</Highlighted>;

		let BeforeItems: React.ReactElement[] = [];
		let AfterItems: React.ReactElement[] = [];
		if (index === 0 && start > 0) {
			BeforeItems = BeforeItems.concat([<>{text.slice(0, start)}</>]);
		}

		if (index > 0) {
			// @ts-ignore
			const [_prevStart, prevEnd] = matches[index - 1];
			if (start - prevEnd > 0) {
				BeforeItems = BeforeItems.concat([<>{text.slice(prevEnd + 1, start)}</>]);
			}
		}

		if (index === matches.length - 1 && end < text.length - 1) {
			AfterItems = [<>{text.slice(end + 1, text.length)}</>];
		}

		return [...acc, ...BeforeItems, Current, ...AfterItems];
	}, []);
};
